import SemanticPageDocument from '@/components/semantic/SemanticPageDocument';
import { getSemanticPageByPath } from '@/lib/semantic-content/pages';
import NotFound from '@/pages/NotFound';

export default function AIOperatingSystem() {
  const page = getSemanticPageByPath('/ai-operating-system');

  return page ? <SemanticPageDocument page={page} /> : <NotFound />;
}
